import { Global } from '@mantine/core';

export default function GlobalStyles() {
  return (
    <Global
      styles={{
        a: {
          textDecoration: 'none',
          color: '#5622F4',
        },
        width: '100%',
        height: '100%',
        minHeight: '100vh',
      }}
    />
  );
}
